module.exports = __webpack_public_path__ + "static/himmel-und-holle-01-fff9278196d72b722dc17d3e5176daad.jpg";